module.exports = "/**\r\n * Created by C5023716 on 12/16/2015.\r\n */\r\n"